import { NgModule } from '@angular/core';
import { MultiSelectAutocompleteComponent } from './multi-select-autocomplete.component';

@NgModule({
  imports: [MultiSelectAutocompleteComponent],
  exports: [MultiSelectAutocompleteComponent],
})
export class MultiSelectAutocompleteModule {}
